module.exports = __webpack_public_path__ + "img/facebook3.98417245.png";